import {payment_new_create,
        payment_load_bydate,
        paymentacct_load_all,
        payee_load_all,
        payee_load_active,
        paytype_load_all,
        acctitems_load_all,
        payment_update_byid,
        paymenttemplate_new_create,
        paymenttemplate_load_byuserid,
        paymenttemplate_update_byid,
        payment_create_bytemplate,
        payee_update_byid,
        paymentacct_update_byid,
        acctitems_update_byid,
        payment_load_bypayee
    } from '../../Models/payment'


//====== ON CREATE PAYMENT DATA ======
export const onCreatePayment = (data) => {
    return new Promise((resolve, reject) => {
        payment_new_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onCreatePaymentByTemplate = (data,invdate) => {
    return new Promise((resolve, reject) => {
        payment_create_bytemplate(data,invdate).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onCreateTemplate = (data) => {
    return new Promise((resolve, reject) => {
        paymenttemplate_new_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onLoadTemplate = (data) => {
    return new Promise((resolve, reject) => {
        paymenttemplate_load_byuserid(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onUpdatePayment = (data) => {
    return new Promise((resolve, reject) => {
        payment_update_byid(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data:val.data})
        }).
        catch((error) => {
            console.log("error: ",error)
            reject({ status: error,msg: "An unexpected error occurred. Contact your system administrator "})
        })
    })
}

export const onUpdateTemplate = (data) => {
    return new Promise((resolve, reject) => {
        paymenttemplate_update_byid(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data:val.data})
        }).
        catch((error) => {
            console.log("error: ",error)
            reject({ status: error,msg: "An unexpected error occurred. Contact your system administrator "})
        })
    })
}

export const onUpdatePayee = (data) => {
    return new Promise((resolve, reject) => {
        payee_update_byid(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data:val.data})
        }).
        catch((error) => {
            console.log("error: ",error)
            reject({ status: error,msg: "An unexpected error occurred. Contact your system administrator "})
        })
    })
}

export const onUpdateAccountItems = (data) => {
    return new Promise((resolve, reject) => {
        acctitems_update_byid(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data:val.data})
        }).
        catch((error) => {
            console.log("error: ",error)
            reject({ status: error,msg: "An unexpected error occurred. Contact your system administrator "})
        })
    })
}

export const onUpdatePaymentAcct = (data) => {
    return new Promise((resolve, reject) => {
        paymentacct_update_byid(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data:val.data})
        }).
        catch((error) => {
            console.log("error: ",error)
            reject({ status: error,msg: "An unexpected error occurred. Contact your system administrator "})
        })
    })
}

export const onLoadPayment = (data) => {
    return new Promise((resolve, reject) => {
        payment_load_bydate(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onLoadPaymentByPayee = (data) => {
    return new Promise((resolve, reject) => {
        payment_load_bypayee(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onLoadPaymentAcct = (data) => {
    return new Promise((resolve, reject) => {
        paymentacct_load_all(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onLoadPayee = (data) => {
    return new Promise((resolve, reject) => {
        payee_load_all(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}
export const onLoadPayeeActive = (data) => {
    return new Promise((resolve, reject) => {
        payee_load_active(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}
export const onLoadPaytype = (data) => {
    return new Promise((resolve, reject) => {
        paytype_load_all(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onLoadAccoutItems = (data) => {
    return new Promise((resolve, reject) => {
        acctitems_load_all(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data ,departmentdata: val.departmentdata,userdata: val.userdata })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}